<template>
  <div class="container">
    <div class="tabbar">
      <div class="tabhead" :class="showhead?'backhead':''">
        <div v-show="showhead&&!showtab" class="smalllogo">
          <img src="../assets/image/logo.png" alt="">
        </div>
        <div class="tabicon" @click="tabclick">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div v-show="showtab" class="logo">
          <img src="../assets/image/logo.png" alt />
          <span>全积分官网</span>
        </div>
      </div>

      <div v-show="showtab" class="tabbox">
        <div class="tabitem">
          <span :class="index==0?'bottomborder':''" v-anchor="0" @click="thisitem(0)">首页</span>
        </div>
        <div class="tabitem">
          <span :class="index==1?'bottomborder':''" v-anchor="1" @click="thisitem(1)">产品与服务</span>
        </div>
        <div class="tabitem">
          <span :class="index==2?'bottomborder':''" v-anchor="2" @click="thisitem(2)">四大价值观体现</span>
        </div>
        <div class="tabitem">
          <span :class="index==3?'bottomborder':''" v-anchor="3" @click="thisitem(3)">解决之道</span>
        </div>
        <div class="tabitem">
          <span :class="index==4?'bottomborder':''" v-anchor="4" @click="thisitem(4)">关于我们</span>
        </div>
      </div>
    </div>
    <div class="swiper title" :id="'anchor-'+0" data-value="0">
      <swiper :options="swiperOption" ref="myswiper">
        <swiper-slide>
          <div class="lunbo">
            <img class="imgsize" src="../assets/image/swiper2.jpg" alt />
            <div class="logo">
              <img src="../assets/image/logo.png" alt />
              <p>全积分官网</p>
            </div>
            <div class="lunbocontent">
              <ul>
                <li>一站式积分营销服务商</li>
                <li>50+机场 1000+家商户</li>
              </ul>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="lunbo">
            <img class="imgsize" src="../assets/image/swiper4.jpg" alt />
            <div class="logo">
              <img src="../assets/image/logo.png" alt />
              <p>全积分官网</p>
            </div>
            <div class="lunbocontent">
              <ul>
                <li>积分营销服务平台</li>
                <li>为2亿常旅客提供积分兑换和航空里程累积服务</li>
              </ul>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="box">
      <div class="title" :id="'anchor-'+1" data-value="1">产品与服务</div>
      <div class="products">
        <div class="item">
          <img src="../assets/image/pro_01.png" alt />
          <span>积分管理</span>
        </div>
        <div class="item">
          <img src="../assets/image/pro_02.png" alt />
          <span>积分支付</span>
        </div>
        <div class="item">
          <img src="../assets/image/pro_03.png" alt />
          <span>积分累积</span>
        </div>
      </div>
      <div class="title top" :id="'anchor-'+2" data-value="2">四大价值观体现</div>
      <div class="fourblock">
        <div class="block">
          <img src="../assets/image/icon/icon1.png" alt />
          <div class="blocktitle">积分支付</div>
          <ul>
            <li>
              <span>航司、银行会员在机场等出行场景消费，扫店铺二维码，用积分结账。</span>
            </li>
            <li>
              <span>会员在全积分公司的非航合作商户消费，可累积航空里程。</span>
            </li>
          </ul>
        </div>
        <div class="block">
          <img src="../assets/image/icon/icon2.png" alt />
          <div class="blocktitle">积分营销</div>
          <ul>
            <li>
              <span>我们的技术和数据 ，可加深对用户了解，帮助积分企业分析会员、激活会员，为企业会员精细化管理与营销提供决策依据。</span>
            </li>
          </ul>
        </div>
        <div class="block">
          <img src="../assets/image/icon/icon3.png" alt />
          <div class="blocktitle">权益营销</div>
          <ul>
            <li>
              <span>依据会员积分兑换轨迹与消费大数据 ，为企业支付营销 &数据营销提供支撑，向目标用户精准推送优惠权益。</span>
            </li>
          </ul>
        </div>
        <div class="block">
          <img src="../assets/image/icon/icon4.png" alt />
          <div class="blocktitle">品牌传播</div>
          <ul>
            <li>
              <span>通过积分连接机场商业、本地生活，让积分企业品牌及会员计划常态触达 5亿+优质流量场景。</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="title top" :id="'anchor-'+3" data-value="3">解决之道</div>
      <div class="cardbox">
        <div class="produce">“ 技术 + 场景 + 运营 + 营销 ”一站式定制服务</div>
        <div class="card">
          <div class="image">
            <img src="../assets/image/road1.png" alt />
          </div>
          <div class="space"></div>
          <div class="cardcontent right">
            <div class="cardtitle">积分企业</div>
            <ul>
              <li>积分营销的优质场景自我开发难、运营难。</li>
              <li>一站式服务激活会员计划，促进“提直降代”。</li>
            </ul>
          </div>
        </div>
        <div class="card rightimg">
          <div class="image">
            <img src="../assets/image/road2.png" alt />
          </div>
          <div class="space"></div>
          <div class="cardcontent left">
            <div class="cardtitle">场景商户</div>
            <ul>
              <li>传统经营方式获客、增收低效，手段困乏。</li>
              <li>一站式服务实现积分支付获客、支付营销蓄客，提升场景流量价值。</li>
            </ul>
          </div>
        </div>
        <div class="card">
          <div class="image">
            <img src="../assets/image/road3.png" alt />
          </div>
          <div class="space"></div>
          <div class="cardcontent right">
            <div class="cardtitle">常旅客</div>
            <ul>
              <li>积分账号管理不便，不同行业积分无法归集与使用。</li>
              <li>实现积分兑换和积分累积的便利快捷。</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="title top" :id="'anchor-'+4" data-value="4">关于我们</div>
      <div class="aboutus">
        <div class="aboutusimg">
          <img src="../assets/image/info.jpg" alt />
        </div>
        <ul>
          <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;全积分公司是一家积分支付与数据营销服务商。依托机场等出行场景，为企业会员提供积分兑换和非航消费累积航空里程服务。</li>
          <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;通过一站式服务平台为积分企业提供存量会员激活、新用户导流；为场景商户引流增收。实现积分兑换、累积的便利化、高频化。基于积分兑换轨迹与消费大数据，开展大数据服务业务。</li>
        </ul>
      </div>
      <div class="ouspro">
        <div class="proitem">我们的理念</div>
        <div class="proitem">我们的使命</div>
        <div class="proitem">我们的目标</div>
      </div>
      <div class="procon">
        <div class="proconitem">
          <img src="../assets/image/one.png" alt />
          <span>
            <p>为企业会员忠诚度管理加分</p>
          </span>
        </div>
        <div class="proconitem">
          <img src="../assets/image/two.png" alt />
          <span>
            <p>用积分连接生活让积分更有活力</p>
          </span>
        </div>
        <div class="proconitem">
          <img src="../assets/image/three.png" alt />
          <span>
            <p>构建大数据驱动的积分+营销生态</p>
          </span>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="tab">
        <div class="tabitem">
          <a href="javascript:void(0)" v-anchor="0">首页</a>
        </div>
        <div class="tabitem">
          <a href="javascript:void(0)" v-anchor="1">产品与服务</a>
        </div>
        <div class="tabitem">
          <a href="javascript:void(0)" v-anchor="4">关于我们</a>
        </div>
      </div>
      <div class="info">
        <div class="leftinfo">
          <div class="infoitem">
            <span>
              <img src="../assets/image/icon/contact.png" alt />
            </span>
            <span>联系我们：</span>
            <span>
              <a href="tel:02886952195">028-86952195</a>
            </span>
          </div>
          <div class="infoitem">
            <span>
              <img src="../assets/image/icon/tel.png" alt />
            </span>
            <span>客服中心：</span>
            <span>
              <a href="tel:4000360195">4000-360-195</a>
            </span>
          </div>
          <div class="address">
            <span>地址：</span>
            <span>高新区盛邦街366号凯旋南城B座 1410</span>
          </div>
          <div class="address">
            <span>Copyright © 2018 蜀ICP备17013358号 成都全积分网络科技有限公司</span>
          </div>
        </div>
        <div class="rightinfo">
          <div class="qjfcode">
            <img src="../assets/image/erweima/fenfenduierweima.png" alt />
          </div>
          <p>全积分</p>
        </div>
      </div>
    </div>
    <div class="maodian">
      <a href="javascript:void(0)" v-anchor="0" @click="thisitem(0)" :class="index==0?'yes':'no'"></a>
      <a href="javascript:void(0)" v-anchor="1" @click="thisitem(1)" :class="index==1?'yes':'no'"></a>
      <a href="javascript:void(0)" v-anchor="2" @click="thisitem(2)" :class="index==2?'yes':'no'"></a>
      <a href="javascript:void(0)" v-anchor="3" @click="thisitem(3)" :class="index==3?'yes':'no'"></a>
      <a href="javascript:void(0)" v-anchor="4" @click="thisitem(4)" :class="index==4?'yes':'no'"></a>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "HelloWorld",
  components: { swiper, swiperSlide },
  data() {
    return {
      index: 2,
      showtab: false,
      showhead: false,
      scrollyes: false,
      showborder: 0,
      swiperOption: {
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          dynamicBulluets: true,
          clickable: true
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        }
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.myswiper.swiper;
    }
  },
  created() {},
  mounted() {
    console.log('yes')
    if (this._isMobile()) {
      window.addEventListener("scroll", this.scrollEvent, false);
    } else {
      window.addEventListener("mousewheel", this.handleScroll, false);
    }
    this.swiper.slideTo(3, 1000, false); 
    window.onresize = () => {
      window.location.reload();
    }
  },
  methods: {
    handleScroll() {
      var scrollTop = document.documentElement.scrollTop + 400;
      var title = document.getElementsByClassName("title");
      this.showtab = false;
      if (scrollTop > 400) {
        this.showhead = true;
        this.scrollyes = true;
      } else {
        if (this.showtab) {
          this.showhead = true;
        } else {
          this.showhead = false;
        }
        this.scrollyes = false;
      }
      if (scrollTop >= title[4].offsetTop) {
        this.index = 4;
      } else if (scrollTop >= title[3].offsetTop) {
        this.index = 3;
      } else if (scrollTop >= title[2].offsetTop) {
        this.index = 2;
      } else if (scrollTop >= title[1].offsetTop) {
        this.index = 1;
      } else if (scrollTop >= title[0].offsetTop) {
        this.index = 0;
      }
    },
    scrollEvent() {
      var bodyscrolltop = document.body.scrollTop;
      var title = document.getElementsByClassName("title");
      this.showtab = false;
      if (bodyscrolltop > title[1].offsetTop) {
        this.showhead = true;
        this.scrollyes = true;
      } else {
        if (this.showtab) {
          this.showhead = true;
        } else {
          this.showhead = false;
        }
        this.scrollyes = false;
      }
      if (bodyscrolltop >= title[4].offsetTop) {
        this.index = 4;
      } else if (bodyscrolltop >= title[3].offsetTop) {
        this.index = 3;
      } else if (bodyscrolltop >= title[2].offsetTop) {
        this.index = 2;
      } else if (bodyscrolltop >= title[1].offsetTop) {
        this.index = 1;
      } else if (bodyscrolltop >= title[0].offsetTop) {
        this.index = 0;
      }
    },
    tabclick() {
      this.showtab = !this.showtab;
      if (this.showtab) {
        this.showhead = true;
      } else {
        if (this.scrollyes) {
          this.showhead = true;
        } else {
          this.showhead = false;
        }
      }
    },
    thisitem(e) {
      console.log(e);
      this.index = e;
      this.showtab = false;
      this.showhead = false;
      document.body.scrollTop =
        document.getElementsByClassName("title")[e].offsetTop - 50;
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  }
};
</script>
<style scoped>
.container {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.tabbar {
  position: fixed;
  width: 100%;
  z-index: 100;
}
.tabhead {
  width: 100%;
  height: 80px;
}
.backhead {
  background-color: black;
}
.tabicon {
  position: absolute;
  top: 20px;
  right: 10px;
  width: 60px;
  height: 40px;
}
.tabicon span {
  width: 40px;
  height: 4px;
  background-color: #ffffff;
  display: block;
  margin: 6px auto;
}
.tabbox {
  width: 100%;
  height: auto;
  background-color: black;
  padding-top: 20px;
  padding-bottom: 20px;
}
.tabbox .tabitem {
  width: 100%;
  font-size: 28px;
  margin: 20px auto;
  text-align: center;
}
.bottomborder {
  border-bottom: 2px solid #ffffff;
}
.tabbox .tabitem span {
  color: #ffffff;
}
.maodian {
  position: fixed;
  right: 20px;
  top: 30%;
  height: 400px;
  width: 40px;
  display: none;
}
.maodian a {
  display: block;
  width: 28px;
  height: 28px;
  margin: 20px;
}
.yes {
  background-color: #ffffff;
  border: 2px solid rgb(233, 0, 132);
}
.no {
  border: 2px solid rgb(233, 0, 132);
  background-color: rgb(233, 0, 132);
}
.top {
  margin-top: 60px;
}
.lunbo {
  position: relative;
}
.lunbo .lunbocontent {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 96%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  align-content: center;
  color: #ffffff;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.45);
}
.lunbo .lunbocontent ul {
  width: 100%;
  text-align: center;
}
.lunbo .lunbocontent ul li {
  list-style: none;
  margin: 10px;
  font-size: 28px;
}
.lunbo .lunbocontent ul li:nth-child(1) {
  font-size: 50px;
}
.logo {
  position: absolute;
  top: 20px;
  left: 40px;
  width: 160px;
  z-index: 999;
  opacity: 1;
  font-size: 28px;
  color: #ffffff;
  font-weight: normal;
}
.smalllogo{
  position: absolute;
  /* width: 180px; */
  height: 60px;
  left: 0;
  top: 5px;
  /* background-color: #ffffff; */
}
.logo p {
  padding: 0;
  margin: 0;
  line-height: 10px;
  white-space: nowrap;
}
img {
  width: 100%;
  height: 100%;
}
.box {
  box-sizing: border-box;
  max-width: 1406px;
  padding: 20px;
  margin: 0 auto;
}
.title {
  font-size: 40px;
  font-weight: bold;
  line-height: 60px;
  margin-bottom: 30px;
  letter-spacing: 5px;
  font-family: "PingFang-SC-Regular";
}
.products {
  width: 100%;
  display: flex;
  max-width: 1366px;
  margin: 0 auto;
  box-sizing: border-box;
  justify-content: space-between;
}
.item {
  position: relative;
  width: 30%;
  color: #ffffff;
  font-size: 30px;
  background-color: #e3e7eb;
  background-repeat: no-repeat;
  background-size: cover;
}
.item span {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  font-size: 34px;
  box-sizing: border-box;
  text-align: center;
  letter-spacing: 5px;
  padding-top: 90%;
  background-color: rgba(0, 0, 0, 0.3);
}
.fourblock {
  width: 100%;
  margin-bottom: 60px;
  display: flex;
  justify-content: space-around;
  box-sizing: border-box;
  max-width: 1366px;
  flex-wrap: wrap;
  margin: 0 auto;
}
.block {
  box-shadow: -2px -2px 28px 0px rgba(252, 187, 224, 0.3);
  width: 300px;
  margin-bottom: 40px;
  padding: 4px;
  padding-bottom: 30px;
  padding-top: 30px;
  box-sizing: border-box;
}
.block img {
  height: 50px;
  width: auto;
  margin: 0 auto;
}
.blocktitle {
  text-align: center;
  color: rgb(233, 0, 132);
  font-size: 34px;
  letter-spacing: 5px;
}
.block ul {
  text-align: left;
  padding-left: 40px;
}
.block ul li {
  list-style-type: disc;
  margin-top: 6px;
  font-size: 28px;
  color: rgb(233, 0, 132);
}
.block ul li span {
  color: rgb(50, 50, 50);
  letter-spacing: 3px;
  font-size: 28px;
}

.cardbox {
  width: 100%;
  max-width: 1366px;
  margin-bottom: 60px;
  margin: 0 auto;
  box-sizing: border-box;
}
.cardbox .produce {
  font-size: 28px;
  margin: 0 auto;
  text-align: center;
}
.card {
  position: relative;
  margin-top: 60px;
}
.card .image {
  width: 70%;
}
.card .space {
  height: 120px;
}
.cardcontent {
  width: 52%;
  font-size: 28px;
  position: absolute;
  bottom: 0;
  text-align: left;
  padding: 20px;
  box-shadow: -2px -2px 28px 0px rgba(252, 187, 224, 0.3);
  width: #ffffff;
  background-color: rgba(255, 255, 255, 0.9);
}
.cardcontent .cardtitle {
  color: rgb(233, 0, 132);
  font-size: 34px;
}
.cardcontent ul {
  margin-left: 20px;
  max-width: 380px;
  padding: 10px;
  box-sizing: border-box;
}
.cardcontent ul li {
  list-style: none;
  font-size: 26px;
  margin: 20px;
}
.right {
  right: 0;
}
.rightimg {
  position: relative;
  height: 580px;
}
.rightimg .image {
  position: absolute;
  right: 0;
}
.left {
  left: 0;
  top: 200px;
}
.aboutus {
  width: 100%;
  margin: 40px auto;
  max-width: 1366px;
  box-sizing: border-box;
  position: relative;
}
.aboutusimg {
  width: 100%;
  max-width: 800px;
}
.aboutus ul {
  position: absolute;
  right: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.4);
  height: 99%;
  width: 100%;
  color: #ffffff;
  letter-spacing: 4px;
  font-size: 28px;
  text-align: left;
  padding: 20px;
  box-sizing: border-box;
  min-width: 566px;
}
.aboutus ul li {
  list-style: none;
  padding: 0;
  margin: 0;
}
.ouspro {
  width: 100%;
  max-width: 1366px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.ouspro .proitem {
  width: 30%;
  height: 120px;
  line-height: 120px;
  text-align: center;
  color: #ffffff;
  font-size: 28px;
  background-color: rgba(0, 0, 0, 0.4);
}
.procon {
  width: 100%;
  max-width: 1366px;
  display: flex;
  margin: 40px auto;
  justify-content: space-between;
}
.procon .proconitem {
  width: 30%;
  position: relative;
}
.procon .proconitem span {
  position: absolute;
  top: 0;
  left: 0;
  text-align: center;
  padding: 10px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  color: #ffffff;
  display: flex;
  align-items: center;
  font-size: 24px;
  background-color: rgba(19, 19, 19, 0.5);
}
.procon .proconitem span p {
  width: 100%;
  text-align: center;
}
.footer {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  background-color: rgb(77, 77, 77);
}
.tab {
  width: 100%;
  max-width: 1366px;
  display: flex;
  justify-content: left;
  margin: 0 auto;
  font-size: 26px;
  color: #ffffff;
  letter-spacing: 4px;
}
.tab .tabitem {
  margin-right: 20px;
}
.tab .tabitem a {
  text-decoration: none;
  color: #ffffff;
}
.info {
  width: 100%;
  max-width: 1366px;
  color: #ffffff;
  font-size: 24px;
  display: flex;
  justify-content: space-between;
  text-align: left;
  margin: 0 auto;
}
.info .infoitem {
  height: 26px;
  display: flex;
  line-height: 32px;
  margin-top: 20px;
  align-items: center;
  align-content: center;
}
.info .infoitem span {
  margin-right: 10px;
  height: 100%;
}
.info .infoitem span img {
  width: auto;
  height: 100%;
}
.info .infoitem span a {
  text-decoration: none;
  font-size: 28px;
  color: #ffffff;
}
.address {
  margin-top: 10px;
}
.rightinfo {
  text-align: center;
  margin-left: 20px;
}
.rightinfo .qjfcode {
  width: 140px;
}

@media screen and (min-width: 800px) {
  .aboutus ul {
    width: 566px;
  }
  .maodian {
    display: block;
  }
  .lunbo .lunbocontent {
    height: 98%;
  }
  .tabbar {
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  .lunbo .lunbocontent {
    height: 98%;
  }
}
@media screen and (min-width: 1400px) {
  .lunbo .lunbocontent {
    height: 99%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue